import type React from "react";
import { createContext, useContext } from "react";
import type { IGridVirtualizedSelectProps } from "./types";

export interface ListVirtualizedSelectContextValue<DataGetId, Data extends DataGetId> {
  itemContent: IGridVirtualizedSelectProps<DataGetId, Data>["itemContent"];
  getId: IGridVirtualizedSelectProps<DataGetId, Data>["getId"];
  selectedItems: IGridVirtualizedSelectProps<DataGetId, Data>["selectedItems"];
  handleSelect: (data: Data, index: number) => void;
  disabledItems: IGridVirtualizedSelectProps<DataGetId, Data>["disabledItems"];
}

export interface ListVirtualizedSelectContextProviderProps<DataGetId, Data extends DataGetId> {
  value: ListVirtualizedSelectContextValue<DataGetId, Data>;
  children: React.ReactNode;
}

export const context = createContext<unknown>(null);
export const useListVirtualizedSelectContext = () => useContext(context);
export const ListVirtualizedSelectContextProvider = <DataGetId, Data extends DataGetId>({
  value,
  children,
}: ListVirtualizedSelectContextProviderProps<DataGetId, Data>) => {
  return <context.Provider value={value}>{children}</context.Provider>;
};
